module.exports = __webpack_public_path__ + "img/select-position.ce6a9fab.png";